import { render } from "./Turmas.vue?vue&type=template&id=207a9556&scoped=true"
const script = {}

import "./Turmas.vue?vue&type=style&index=0&id=207a9556&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-207a9556"

export default script